<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-content">
        <div class="is-flex is-flex-column content-center">
          <div class="fa-4x is-primary">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
          <h1 class="subtitle">Please wait, loading...</h1>
        </div>
      </div>
    </div>
<!--    <div class="table__wrapper" v-if="transactions.length > 0">-->
<!--      <table class="table is-fullwidth">-->
<!--        <thead>-->
<!--          <tr>-->
<!--            <th>{{$t("wallet.txDate")}}</th>-->
<!--            <th>{{$t("wallet.txContractAction")}}</th>-->
<!--            <th>{{$t("wallet.txFrom")}}</th>-->
<!--            <th>{{$t("wallet.txTo")}}</th>-->
<!--            <th>{{$t("wallet.txQty")}}</th>-->
<!--            <th>{{$t("wallet.txStatus")}}</th>-->
<!--          </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--          <tr v-for="(tx, index) in orderedTx" :key="index"-->
<!--          v-on:click="showSidebar(tx)" class="clickable">-->
<!--          <td>{{ tx.block_time | moment('DD MMM YY') }}</td>-->
<!--          <td>{{tx.action_trace.act.account}}/{{tx.action_trace.act.name}}</td>-->
<!--          <td><tx-auth :items="tx.action_trace.act.authorization" /></td>-->
<!--          <td>{{tx.action_trace.receipt.receiver}}</td>-->
<!--          <td class="has-text-left">-->
<!--            {{ tx.action_trace.act.data.quantity || '-'}}-->
<!--          </td>-->
<!--          <td>-->
<!--            <span v-if="linkedAccount.account  === tx.action_trace.receipt.receiver" class="status">{{$t("wallet.txStatusReceived")}}</span>-->
<!--            <span v-else class="status sent">{{$t("wallet.txStatusSent")}}</span>-->
<!--          </td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->
    <div  class="card ">
      <div class="card-content has-text-centered">
        <wallet-providers :isWallet="false"></wallet-providers>
      </div>
    </div>
  </div>
</template>

<script>
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import Heading from '@/components/general/heading'
import EmptyState from '@/components/general/empty-state'
import TxAuth from '@/components/wallet/tx/Auth'
import WalletProviders from '@/components/wallet/providers'
import {mapState} from 'vuex'
import {orderBy} from 'lodash'

export default {
  name: 'transaction',
  components: {
    Columns, Column, Heading, EmptyState, TxAuth, WalletProviders
  },
  computed: {
    ...mapState('walletTx', ['transactions', 'loading']),
    ...mapState('wallet', ['linkedAccount']),
    orderedTx () {
      return orderBy(this.transactions, 'account_action_seq', 'desc')
    }
  },
  methods: {
    showSidebar (item) {
      this.$emit('showSidebar', item)
    },
    loadTransaction () {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

pre {
  background: transparent;
}
h6.heading {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
}

.columns {
  margin: 0;
  padding: 0;
  .column {
    padding: 0 1rem;
  }
}

.columns:not(:last-child) {
  border-bottom: solid 1px #ddd;
}

.tbody {
  font-size: 0.875rem;
  background-color: white;
  border: solid 1px #ddd;
  border-radius: 4px;
  .columns {
    height: 3rem;
    align-items: center;
    cursor: pointer;
    &:hover {
      background-color: $hover-background;
      border-radius: 4px;
    }
  }
}

.status {
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 0.75rem;
  color: $primary;
  text-transform: uppercase;

  &.sent {
    color: #cccccc;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/wallet/transaction-list.vue